package com.dignicate.web.ui.components

import androidx.compose.runtime.Composable
import com.dignicate.web.css.ColorValue
import com.dignicate.web.css.ThemeVar
import com.dignicate.web.css.color
import com.dignicate.web.css.lineHeightUnitless
import com.dignicate.web.css.marginXAuto
import com.dignicate.web.domain.ValueStatement
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.textAlign
import org.jetbrains.compose.web.dom.Article
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Text

@Composable
fun ValuesSection(values: List<ValueStatement>, title: String, description: String) {
    Section(attrs = { id("values"); classes("section") }) {
        Div(attrs = { classes("container") }) {
            H2({ style { fontSize(36.px); fontWeight("700"); marginBottom(12.px); textAlign("center") } }) {
                Text(title)
            }

            P({ style { maxWidth(720.px); marginXAuto(40.px); textAlign("center"); lineHeightUnitless(1.6); color(ColorValue.Var(ThemeVar.Muted)) } }) {
                Text(description)
            }

            Div(attrs = { classes("cards-grid") }) {
                values.forEach { v ->
                    Article(attrs = { classes("service-card") }) {
                        H3(attrs = { classes("card-title") }) { Text(v.title) }
                        P({ style { color(ColorValue.Var(ThemeVar.Muted)); lineHeightUnitless(1.6); marginBottom(16.px) } }) { Text(v.body) }
                    }
                }
            }
        }
    }
}
